export const vialMeta = [
  {
    page: "wastage",
    types: [
      {
        strength: "GIAPREZA 0.5 mg vial NDC: 68547-005-01",
        item: "1409 WAST0005-01",
        internalName: "GIAPREZA WASTAGE PROGRAM 1ML",
        itemDescription: "Giapreza Wastage Program 1ML 0.5MG",
      },
      {
        strength: "GIAPREZA 2.5 mg vial NDC: 68547-501-02",
        item: "1409 WAST0501-02",
        internalName: "GIAPREZA WASTAGE PROGRAM INJ",
        itemDescription: "Giapreza Wastage Program Inj 1ML 2.5MG",
      },
    ],
  },
  {
    page: "warranty",
    types: [
      {
        strength: "GIAPREZA 0.5 mg vial NDC: 68547-005-01",
        item: "1409 RPLMT0005-01",
        internalName: "GIAPREZA WARRANTY PROGRAM 1ML",
        itemDescription: "Giapreza Warranty Program 1ML 0.5MG",
      },
      {
        strength: "GIAPREZA 2.5 mg vial NDC: 68547-501-02",
        item: "1409 RPLMT0501-02",
        internalName: "GIAPREZA WARRANTY PROGRAM 1ML",
        itemDescription: "Giapreza Warranty Program 1ML 2.5MG",
      },
    ],
  },
];
